const CONFIG = {
    namespace: "core.oneplatform.box",
};

export const HANDLERS = {
    ONE_BOX_PAGE: "drift/box/page",
};

export default CONFIG;
